<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :disablePage='disablePage'
      :current='page'>
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
          </div>
          <div v-if="this.$store.state.user.roleType !== 2" class="queryItem">
            <label>门店:</label>
            <storeListSelect class="item" v-model="query.storeIds"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker  type='daterange' placeholder=" 请选择" class="item" v-model.trim='query.createTimeRange' ></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>修改时间:</label>
            <timeStampDatePicker type='daterange' placeholder=" 请选择" class="item" v-model.trim='query.modifiedTimeRange' ></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch(false, clearTemp)">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btn-wrap mb16">
          <span v-if="this.handlePermission('printPrice')">
            <lk-button class="mr8" type="primary" @click="getSelectedPrintData" :disabled="tempPrintIds.length === 0">打印所选</lk-button>
            <!-- <lk-button class="mr8" type="primary" @click="getAllPrintData">打印所有</lk-button> -->
            <lk-button class="mr8" type="primary" @click="printSetting">设置模版</lk-button>
          </span>
                <DownloadButton  @on-click="download" v-if="handlePermission('listPriceDownload')"></DownloadButton>

        </div>
        <lk-table border :columns="columns" :data="tableData"
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          @on-select-all="handleSelectAll"
          @on-select-all-cancel="handleSelectAllCancel"/>
      </div>
    </QueryFrame>
    <lk-modal v-model="printSettingVisiable" title="选择模版" width='550'>
      <div class="modelContent">
        <div class="params">
          <lk-form
            :label-width='75'
            label-position="right">
            <lk-row :gutter='16'>
              <lk-col span='8'>
                <lk-form-item label='模版类型:'>
                  <lk-radio-group v-model="printPriceTemplate"> 
                    <lk-radio :label="1">邻客智慧药房通用模版</lk-radio>
                    <lk-radio :label="2">甘肃省价格监督检查局监制</lk-radio>
                    <lk-radio :label="3">石家庄邻客智慧药房模版</lk-radio>
                    <lk-radio :label="4">青岛邻客智慧药房模板</lk-radio>
                  </lk-radio-group>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </div>
      </div>
      <div slot="footer">
        <lk-button @click="printSettingVisiable = false">取消</lk-button>
        <lk-button @click="confirmPrintSetting" type='primary'>确定</lk-button>
      </div>
    </lk-modal>
     <!--  商品价格标签 开始  -->
    <section id="printArea" ref="print" class="print-area">
      <div  v-for="(printData, index) in printDataList" :key="index">
        <div style="padding-top: 16px;height: 143px;" v-if="priceTemplate == 1">
          <h6 class="no-print">商品标价签</h6>
          <span class="bottomTitle ">{{printData.salePriceVersion.approvedDrugNames}}</span>
          <span class="medicareTitle" v-if="printData.salePriceVersion.isMedicare == 1">医保</span>
          <br>
          <table class="print-table">
            <tbody>
              <tr >
                <td colspan="2" >
                  <span class="no-print">商品编号：</span>
                  <span class="print-prefix">{{printData.salePriceVersion.drugSerialCode}}</span>
                </td>
                <td rowspan="2" colspan="2" style="width:60%">
                  <span class="no-print">零售价：</span>
                  <span class="print-prefix salePrice">{{printData.salePriceVersion.price}}</span>
                </td>
              </tr>
              <tr>
                <td >
                  <span class="no-print">规格：</span>
                  <div
                  :class="[returnClass(printData)]">{{printData.salePriceVersion.specifications ? printData.salePriceVersion.specifications.slice(0, 32) : ''}}</div>
                </td>
                <td style="width:10%">
                  <span class="no-print">计价单位：</span>
                  <span class="goodsUnit2">{{printData.salePriceVersion.goodsUnit}}</span>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="width:40%">
                  <span class="no-print">生产企业：</span>
                  <span
                    :class="{true: 'print-prefix manufacturer2 smaller print-userName', false: 'print-prefix manufacturer3 smaller print-userName'}[(printData.salePriceVersion.manufacturer && printData.salePriceVersion.manufacturer.length > 12) || (printData.salePriceVersion.specifications && printData.salePriceVersion.specifications.length > 10)]">{{ printData.salePriceVersion.manufacturer ? (printData.salePriceVersion.manufacturer).slice(0, 20): '' }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <span class='bottomTitleSmaller2'>发展和改革委员会价格举报电话 12358</span>
          <p v-if="index> 0 && (index+1)%7 ==0" class="page-break"></p>
        </div>
        <div style="padding-top: 2px;height: 153px;padding-left: 20px;"  v-if="priceTemplate == 2">
          <h6 class="no-print">商品标价签</h6>
          <span class="bottomTitleGS ">{{printData.salePriceVersion.approvedDrugNames}}</span>
          <!-- <br> -->
          <div style="height:12px"></div>
          <table class="print-table-LanZhow">
            <tbody>
              <tr>
                <td colspan="2">
                  <span class="no-print">计价单位：</span>
                  <span class="print-prefix-Lanzhou small">{{printData.salePriceVersion.goodsUnit}}</span>
                </td>
                <td colspan="2">
                  <span class="no-print">规格：</span>
                  <span class="print-prefix small">{{printData.salePriceVersion.specifications}}</span>
                </td>
              </tr>
              <tr>

                <td rowspan="2" colspan="2">
                  <span class="no-print">零售价：</span>
                  <span class="print-prefix salePrice">{{printData.salePriceVersion.price}}</span>
                </td>
                <td colspan="2">
                  <span class="no-print">商品编号：</span>
                  <span class="print-prefix small">{{printData.salePriceVersion.drugSerialCode}}</span>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <span class="no-print">条码：</span>
                  <span class="print-prefix small"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style="padding-top: 16px;height: 143px;" v-if="priceTemplate == 3">
          <h6 class="no-print">商品标价签</h6>
          <span class="bottomTitle ">{{printData.salePriceVersion.approvedDrugNames}}</span>
          <br>
          <table class="print-table">
            <tbody>
              <tr >
                <td colspan="2" >
                  <span class="no-print">商品编号：</span>
                  <span class="print-prefix">{{printData.salePriceVersion.drugSerialCode}}</span>
                </td>
                <td rowspan="2" colspan="2" style="width:60%">
                  <span class="no-print">零售价：</span>
                  <span class="print-prefix salePrice">{{printData.salePriceVersion.price}}</span>
                </td>
              </tr>
              <tr>
                <td style="width:30%">
                  <span class="no-print">规格：</span>
                  <div
                  :class="[returnClass(printData)]">{{printData.salePriceVersion.specifications ? printData.salePriceVersion.specifications.slice(0, 32) : ''}}</div>
                </td>
                <td style="width:10%">
                  <span class="no-print">计价单位：</span>
                  <span class="goodsUnit2">{{printData.salePriceVersion.goodsUnit}}</span>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="width:40%">
                  <span class="no-print">生产企业：</span>
                  <span
                    :class="{true: 'print-prefix manufacturer2 smaller print-userName', false: 'print-prefix manufacturer3 smaller print-userName'}[(printData.salePriceVersion.manufacturer && printData.salePriceVersion.manufacturer.length > 12) || (printData.salePriceVersion.specifications && printData.salePriceVersion.specifications.length > 10)]">{{ printData.salePriceVersion.manufacturer ? (printData.salePriceVersion.manufacturer).slice(0, 20): '' }}</span>
                </td>
                <td colspan="2">
                  <span class="no-print">物价员：</span>
                </td>
              </tr>
            </tbody>
          </table>
          <p v-if="index> 0 && (index+1)%7 ==0" class="page-break"></p>
        </div>
        <div style="padding-top: 16px;height: 143px;" v-if="priceTemplate == 4">
          <h6 class="no-print">商品标价签</h6>
          <span class="bottomTitle ">{{printData.salePriceVersion.approvedDrugNames}}</span>
          <br>
          <table class="print-table">
            <tbody>
              <tr >
                <td colspan="2" >
                  <span class="no-print">商品编号：</span>
                  <span class="print-prefix">{{printData.salePriceVersion.drugSerialCode}}</span>
                </td>
                <td rowspan="2" colspan="2" style="width:60%">
                  <span class="no-print">零售价：</span>
                  <span class="print-prefix salePrice">{{printData.salePriceVersion.price}}</span>
                </td>
              </tr>
              <tr>
                <td style="width:30%">
                  <span class="no-print">规格：</span>
                  <div
                  :class="[returnClass(printData)]">{{printData.salePriceVersion.specifications ? printData.salePriceVersion.specifications.slice(0, 32) : ''}}</div>
                </td>
                <td style="width:10%">
                  <span class="no-print">计价单位：</span>
                  <span class="goodsUnit2">{{printData.salePriceVersion.goodsUnit}}</span>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="width:40%">
                  <span class="no-print">生产企业：</span>
                  <span
                    :class="{true: 'print-prefix manufacturer2 smaller print-userName', false: 'print-prefix manufacturer3 smaller print-userName'}[(printData.salePriceVersion.manufacturer && printData.salePriceVersion.manufacturer.length > 12) || (printData.salePriceVersion.specifications && printData.salePriceVersion.specifications.length > 10)]">{{ printData.salePriceVersion.manufacturer ? (printData.salePriceVersion.manufacturer).slice(0, 20): '' }}</span>
                </td>
                <td colspan="2" style="width:40%">
                  <!-- 物价员 -->
                  <div class="pricePerson">{{printData.salePriceVersion.manageName}}</div>
                </td>
              </tr>
            </tbody>
          </table>
          <span class="bottomTitleSmaller2">青岛市价格监督管理局价格监督电话12358</span>
          <p v-if="index> 0 && (index+1)%7 ==0" class="page-break"></p>
        </div>
      </div>
    </section>
    <!--  商品价格标签 结束  -->

  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import sale from '../../services/sale';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import sharedDara from '../../libs/sharedDara';
import user from '../../services/user';
import DownloadButton from '../../components/download/DownloadButton';

export default {
  name: 'priceManage',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame, DownloadButton,
  },
  data() {
    return {
      printTypeDefault: false,
      disablePage: false,
      query: {
        storeIds: [],
        nameMix: '',
        createTimeRange: [],
        modifiedTimeRange: [],
      },
      params: {
        storeIds: [],
        nameMix: '',
      },
      adjustmentReasonList: [], // 调整原因
      columns: [
        {
          type: 'selection',
          minWidth: 60,
          align: 'center',
          fixed: 'left',
        },
        { title: '序号', key: 'number', minWidth: 116 },
        { title: '门店', key: 'salePriceVersionStoreName', minWidth: 116 },
        { title: '商品编码', key: 'salePriceVersionDrugSerialCode', minWidth: 116 },
        { title: '商品名称', key: 'salePriceVersionGoodsName', minWidth: 116 },
        { title: '通用名称', key: 'salePriceVersionApprovedDrugNames', minWidth: 116 },
        { title: '当前销售单价',
          minWidth: 126,
          render: (h, params) => h('span',
            utils.isEmpty(params.row.oldPriceRange) ? params.row.salePriceVersionPrice : params.row.oldPriceRange,
          ),
        },
        { title: '调整销售单价',
          minWidth: 126,
          render: (h, params) => h('span',
            utils.isEmpty(params.row.newPriceRange) ? params.row.newPrice : params.row.newPriceRange,
          ),
        },
        { title: '审批状态', key: 'newApprovalStatus', minWidth: 116 },
        { title: '创建日期', key: 'salePriceVersionCreateTime', minWidth: 116 },
        { title: '规格', key: 'salePriceVersionSpecifications', minWidth: 116 },
        { title: '剂型', key: 'salePriceVersionDosageForm', minWidth: 116 },
        { title: '单位', key: 'salePriceVersionGoodsUnit', minWidth: 116 },
        { title: '供应商', key: 'salePriceVersionSupplier', minWidth: 116 },
        { title: '生产厂家', key: 'salePriceVersionManufacturer', minWidth: 116 },
        { title: '是否拆零', key: 'isUnpack', minWidth: 116 },
        {
          title: '调整原因',
          key: 'salePriceVersionAdjustmentReason',
          minWidth: 116,
        },

        { title: '创建人员', key: 'salePriceVersionCreateUserName', minWidth: 116 },
        { title: '修改日期', key: 'salePriceVersionModifiedTime', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 180,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            this.handlePermission('addPrice')
              ? h('lk-button', {
                props: {
                  type: 'text',
                  size: 'small',
                  disabled: params.row.newApprovalStatus === '审批中',
                },
                on: {
                  click: () => {
                    this.$router.push({
                      name: 'addPrice',
                      params: {
                        id: params.row.salePriceVersionId,
                      },
                    });
                  },
                },
              }, '价格调整') : null,
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'checkPrice',
                    params: {
                      id: params.row.salePriceVersionId,
                    },
                  });
                },
              },
            }, '查看'),
            this.handlePermission('printPrice') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.tempPrintIds = [];
                  this.tempPrintIds.push(params.row.salePriceVersionId);
                  this.getSelectedPrintData();
                },
              },
            }, '打印') : null,
          ]),
        },
      ],
      tableData: [],
      enableStatus: ['全部', '启用', '禁用'],
      approvalStatus: ['', '审批中', '审批成功', '驳回'],
      printDataList: [],
      tempPrintIds: [],
      printSettingVisiable: false,
      printPriceTemplate: 1,
      priceTemplate: 1,
      currentUserInfo: [], // 当前登陆的用户信息
      currentUser: '', // 当前用户名
    };
  },
  methods: {
    returnClass(tempData) {
      if (tempData.salePriceVersion.specifications) {
        if (tempData.salePriceVersion.specifications.length < 10) {
          return 'specifications print-prefix';
        }
        if (tempData.salePriceVersion.specifications.length >= 10 && tempData.salePriceVersion.specifications.length <= 25) {
          return 'specifications2 print-prefix2';
        }
        return 'specifications3 print-prefix2';
      }
      return 'specifications';
    },
    clearTemp() {
      this.tempPrintIds = [];
    },
    printSetting() {
      this.printSettingVisiable = true;
      // this.printPriceTemplate = this.priceTemplate;
    },
    confirmPrintSetting() {
      this.priceTemplate = this.printPriceTemplate;
      this.printSettingVisiable = false;
      localStorage.printPriceTemplate = this.priceTemplate;
      this.$Message.success('设置成功！');
    },
    clear() {
      this.query = {
        storeIds: [],
        nameMix: '',
        createTimeRange: [],
        modifiedTimeRange: [],
      };
    },
    paramsChange() {
      if (this.params.createTimeRange && this.params.createTimeRange[1]) {
        this.params.createTimeStart = new Date(new Date(this.params.createTimeRange[0]).toLocaleDateString()).getTime();
        this.params.createTimeEnd = (new Date(this.params.createTimeRange[1])).getTime();
      }
      if (this.params.modifiedTimeRange && this.params.modifiedTimeRange[1]) {
        this.params.modifiedTimeStart = new Date(new Date(this.params.modifiedTimeRange[0]).toLocaleDateString()).getTime();
        this.params.modifiedTimeEnd = (new Date(this.params.modifiedTimeRange[1])).getTime();
      }
    },
    getData() {
      this.paramsChange();
      this.params.page = this.page;
      this.params.size = this.size;
      // if (this.params.createTime) {
      //   this.params.createTime = (new Date(this.params.createTime)).getTime();
      // }
      sale.listPrice(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          let number = 1;
          res.data.data.list.forEach((item) => {
            const result = {};

            utils.exchangeTable(item, result);

            // result.number = number++;
            result.salePriceVersionCreateTime = utils.exchangeTime(result.salePriceVersionCreateTime);
            if (result.salePriceVersionAdjustmentReason) {
              const id = result.salePriceVersionAdjustmentReason;
              result.salePriceVersionAdjustmentReason = this.adjustmentReasonList[id - 1].name;
            }
            result.salePriceVersionModifiedTime = utils.exchangeTime(result.salePriceVersionModifiedTime);
            // result.salePriceVersionPrice /= 100;
            result.newPrice = result.newPrice ? result.newPrice : '-';
            // result.statusEnable = this.enableStatus[result.statusEnable];

            result.newApprovalStatus = result.newApprovalStatus ? this.approvalStatus[result.newApprovalStatus] : '-';
            result.loading = false;
            result.isUnpack = result.salePriceVersionUnpackMinPkgUnit ? '是' : '否';
            if (this.tempPrintIds.includes(result.salePriceVersionId)) {
              result._checked = true;
            }
            result.number = number++;
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // getAllPrintData() {
    //   if (this.count == 0) {
    //     this.$Message.error('当前无可打印');
    //     return;
    //   }
    //   if (this.count > 1000) {
    //     this.$Message.error('最多支持1000条同时打印，请分批提交');
    //     return;
    //   }
    //   this.paramsChange();
    //   if (this.params.createTime) {
    //     this.params.createTime = (new Date(this.params.createTime)).getTime();
    //   }
    //   sale.getPrintPrice(utils.deletePageAndSize(this.params)).then((res) => {
    //     if (res.data.status === 200) {
    //       this.printDataList = [];
    //       this.printDataList = res.data.data.list;
    //       console.log(this.printDataList);
    //       this.$nextTick(() => {
    //         this.$print(this.$refs.print);
    //       });
    //     } else {
    //       this.$Message.error(res.data.error);
    //     }
    //   }).catch((err) => {
    //     utils.handleError(err);
    //   });
    // },
    getSelectedPrintData() {
      sale.getPrintPrice({ idList: this.tempPrintIds }).then((res) => {
        if (res.data.status === 200) {
          this.printDataList = [];
          this.printDataList = res.data.data.list;
          console.log(this.printDataList);
          this.$nextTick(() => {
            this.$print(this.$refs.print);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleTempSelect(selection, row) {
      if (!this.tempPrintIds.includes(row.salePriceVersionId)) {
        this.tempPrintIds.push(row.salePriceVersionId);
      }
    },
    handleTempCancel(selection, row) {
      for (let i = 0, len = this.tempPrintIds.length; i < len; i++) {
        if (this.tempPrintIds[i] === row.salePriceVersionId) {
          this.tempPrintIds.splice(i, 1);
          break;
        }
      }
    },
    handleSelectAll(selection) {
      selection.forEach((item) => {
        console.log(item.salePriceVersionId);
        if (!this.tempPrintIds.includes(item.salePriceVersionId)) {
          this.tempPrintIds.push(item.salePriceVersionId);
        }
      });
    },
    handleSelectAllCancel() {
      this.tableData.forEach((good) => {
        for (let i = 0, len = this.tempPrintIds.length; i < len; i++) {
          if (this.tempPrintIds[i] === good.salePriceVersionId) {
            this.tempPrintIds.splice(i, 1);
            break;
          }
        }
      });
    },
    getPrintListData() {
      this.printInspectionList(this.tempPrintIds);
    },
    download() {
      const params = Object.assign({}, this.query);
      params.page = 0;
      params.size = 0;

      params.queryCondition = utils.getQueryCondition('.queryContainer');
      // params.startTime = utils.exchangeDate(params.startTime);
      // params.endTime = utils.exchangeDate(params.endTime);
      sale.downloadListPrice(params).then((res) => {
        console.log(res);

        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    if (localStorage.printPriceTemplate) {
      this.priceTemplate = Number(localStorage.printPriceTemplate);
      this.printPriceTemplate = this.priceTemplate;
    }
  },
  mounted() {
    this.adjustmentReasonList = sharedDara.adjustmentReasonList;
    if (!this.handlePermission('addPrice')) {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].key === 'action') {
          this.columns.splice(i, 1);
          i--;
        }
      }
      // this.columns.
    }
    user.authority().then((res) => {
      if (res.data.status == 200) {
        this.currentUserInfo = res.data;
        this.currentUser = this.currentUserInfo.data.sysStore.name;
        if (this.currentUser.includes('石家庄')) {
          // console.log(this.currentUser.includes('石家庄'));
          this.printPriceTemplate = 3;
          this.priceTemplate = 3;
          localStorage.printPriceTemplate = this.priceTemplate;
        }
      }
    }).catch((err) => {
      utils.handleError(err);
    });

    if (this.$store.state.user.roleType === 2) {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].key === 'salePriceVersionStoreName') {
          this.columns.splice(i, 1);
          i--;
        }
      }
    }
    this.$nextTick(() => {
      // this.query.enable = 1;
      // this.query.approval = 1;
    });
    // this.getStoreList();
    // this.getData();
    this.handleSearch(true);
  },
  /* computed: {
    columns() {
      if(this.$store.state.user.roleType !== 1){
        return
      }else{
        return
      }
    },
  }, */
};
</script>
<style lang="less" scoped>
  @media print {
    .print-area {
      display: block;
    }
    .page-break {
      page-break-after: always;
    }
  }
  @media screen {
    .print-area {
      display: none;
    }
  }
  .print-table {
    text-align: left;
    border-collapse: collapse;
    border-spacing: 0px 0px;
    width: 250px;
    height: 75px;
    td,
    th {
      padding: 0px 0px;
      // overflow: hidden;
    }
    .print-prefix {
      display: inline-block;
      color: #000;
      padding-left: 25px;
      min-width: 50px;
      max-width: 150px;
      white-space: nowrap;
    }
    // 1-10
    .specifications {
      width: 100px;
      padding-left: 25px;
      font-size: 12px;
      margin-top: 12px;
      margin-left: -7px;
      &.small {
        padding: 0;
        transform: scale(0.8);
      }
    }
    // 10-24
    .specifications2 {
      width:120px !important;
      // color: red !important;
      color: black;
      font-size: 12px !important;
      margin-left: -15px;
      margin-top: 5px;
      transform: scale(0.6);
      white-space: normal;
    }
    // 25-33
    .specifications3 {
      width:120px !important;
      // color: red !important;
      color: black;
      font-size: 12px !important;
      margin-left: -15px;
      margin-top: -5px;
      max-height: 40px;
      transform: scale(0.6);
      white-space: normal;
    }
    .salePrice {
      font-size: 28px;
      padding:0;
      margin-left: 10px;
      margin-top: 10px;
      font-weight: bold;
    }
    .print-user{
      padding:0;
      margin-left: 10px;
    }

    .goodsUnit2{
      display: inline-block;
      color: #000;
      white-space: nowrap;
      font-size: 12px;
      white-space: normal;
      transform: scale(0.8);
      margin-top: 5px;
      margin-left: -18px;
    }
    .goodsUnit {
      display: inline-block;
      color: #000;
      white-space: nowrap;
      font-size: 12px;
      white-space: normal;
      transform: scale(0.8);
      margin-top: 5px;
    }
    .manufacturer {
      font-size: 12px;
      white-space: normal;
      margin-left: 10px;
      &.small {
        padding: 0;
        // transform-origin: 0 0;
        transform: scale(0.8);
      }
      &.smaller {
        width: 250px;
        padding: 0;
        transform: scale(0.7);
      }
    }
    // 两行
    .manufacturer2 {
      font-size: 12px;
      white-space: normal;
      margin-left: 10px;
      margin-top:-3px;
      &.small {
        padding: 0;
        // transform-origin: 0 0;
        transform: scale(0.8);
      }
      &.smaller {
        width: 250px;
        padding: 0;
        transform: scale(0.7);
      }
    }
    // 1行
    .manufacturer3 {
      font-size: 12px;
      white-space: normal;
      margin-left: 10px;
      margin-top: 5px;
      &.small {
        padding: 0;
        // transform-origin: 0 0;
        transform: scale(0.8);
      }
      &.smaller {
        width: 250px;
        padding: 0;
        transform: scale(0.7);
      }
    }
    .manufacturer {
      font-size: 12px;
      white-space: normal;
      margin-left: 10px;
      &.small {
        padding: 0;
        // transform-origin: 0 0;
        transform: scale(0.8);
      }
      &.smaller {
        width: 250px;
        padding: 0;
        transform: scale(0.7);
      }
    }
    .print-userName {
      height: 28.8px;
      transform: scale(0.8);
    }
  }
   .bottomTitle {
      font-size: 12px;
      color: #000;
      white-space: nowrap;
      margin-left: 25px;
      margin-top: -10px;
      margin-bottom: 5px;
      display: block;
      position: absolute;
    }
    .bottomTitleGS {
      font-size: 12px;
      color: #000;
      white-space: nowrap;
      margin-left: 25px;
      margin-top: -3px;
      margin-bottom: 5px;
      display: block;
      position: absolute;
    }
    .bottomTitleSmaller {
      font-size: 12px;
      white-space: nowrap;
      color: #000;
      margin-left: 20px;
      margin-top: -6px;
      display: block;
      position: absolute;
      transform: scale(0.8);
    }
    // 2行
    .bottomTitleSmaller2 {
      font-size: 12px;
      white-space: nowrap;
      color: #000;
      margin-left: 98px;
      margin-top: -16px;
      display: block;
      position: absolute;
      transform: scale(0.6);
    }
    // 1行
    .bottomTitleSmaller3 {
      font-size: 12px;
      white-space: nowrap;
      color: #000;
      margin-left: 40px;
      margin-top: -10px;
      display: block;
      position: absolute;
      transform: scale(0.6);
    }

.print-table-LanZhow {
    text-align: left;
    border-collapse: collapse;
    border-spacing: 0px 0px;
    width: 290px;
    height: 80px;
    td {
      width: 145px;
    }
    th {
      padding: 0px 0px;
      overflow: hidden;
    }
    // 0-10个字符
    .print-prefix {
      display: inline-block;
      color: #000;
      padding-left: 20px;
      min-width: 50px;
      max-width: 300px;
      white-space: nowrap;
      &.small {
        transform: scale(0.8);
      }
    }
    // 超过10字符
    .print-prefix2 {
      display: inline-block;
      color: #000;
      padding-left: 20px;
      min-width: 50px;
      max-width: 300px;
      transform: scale(0.5);
    }
    .print-prefix-Lanzhou {
      display: inline-block;
      color: #000;
      padding-left: 30px;
      min-width: 50px;
      max-width: 150px;
      white-space: nowrap;
      &.small {
        transform: scale(0.8);
      }
    }
    .specifications {
      min-width: 10px;
      font-size: 12px;
      &.small {
        padding: 0;
        transform: scale(0.8);
      }
    }
    .salePrice {
      font-size: 28px;
      font-weight: bold;
    }
    .manufacturer {
      font-size: 12px;
      white-space: normal;
      &.small {
        padding: 0;
        transform: scale(0.8);
      }
      &.smaller {
        padding: 0;
        transform: scale(0.7);
      }
    }
  }
  .person {
    margin-left: 90px;
    transform: scale(0.8);
    display: block;
    font-size: 8px;
    color: #000;
  }
  .pricePerson {
    font-size: 12px;
    white-space: nowrap;
    color: #000;
    margin-left: -15px;
    margin-top: -15px;
    display: block;
    position: absolute;
    transform: scale(0.8);
  }
  .medicareTitle {
      font-size: 12px;
      color: #000;
      white-space: nowrap;
      margin-left: 220px;
      margin-top: -10px;
      margin-bottom: 5px;
      display: block;
      position: absolute;
    }
    .textRed {
      color: red;
    }
    .textYellow {
      color: blue;
    }
</style>
